import { render, staticRenderFns } from "./InviteCustomers.vue?vue&type=template&id=56be81d1&"
import script from "./InviteCustomers.vue?vue&type=script&lang=ts&"
export * from "./InviteCustomers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports